import { fetchQuery, graphql } from "relay-runtime"
import { betterDocSelectedRecommendationsQuery } from "@/modules/admin/better-doc/services/__generated__/betterDocSelectedRecommendationsQuery.graphql"
import { BetterDocOpenRecommendationsResult } from "@/modules/admin/better-doc/services/betterDocRecommendedRecommendationsQuery"
import { RelayEnvironment } from "@/relay-environment"
import { Country } from "@/types/__generated__/union-types"

const query = graphql`
  query betterDocSelectedRecommendationsQuery($insuranceCountry: Country!) {
    de_betterDocSelectedRecommendations(insuranceCountry: $insuranceCountry) {
      status
      httpStatusCode
      errorReason
      exchangeId
      recommendations {
        recommendationId
        state
        version
        partnerPatientId
        partnerSessionId
        localSessionId
        selectionType
        selectionId
        medics {
          selectionId
        }
        selectedMedic {
          name
        }
      }
    }
  }
`

export const fetchBetterDocSelectedRecommendations = (
  insuranceCountry: Country,
): Promise<BetterDocOpenRecommendationsResult> =>
  fetchQuery<betterDocSelectedRecommendationsQuery>(
    RelayEnvironment,
    query,
    { insuranceCountry },
    { fetchPolicy: "network-only" },
  )
    .toPromise()
    .then((response) => {
      if (!response) {
        throw new Error("BetterDoc returned no response")
      }

      return response.de_betterDocSelectedRecommendations
    })
